// extracted by mini-css-extract-plugin
export default {"icon":"IconSkills_icon_xi12V","isVisible":"IconSkills_isVisible_nM18C","orange":"IconSkills_orange_owvC4","green":"IconSkills_green_FEjQG","violet":"IconSkills_violet_YtAsf"};